import React, { useState } from 'react';
import { Loading, Toast } from 'react-vant';
import { useTranslation } from 'react-i18next';

const NetworkErrorPage = ({ onRetry }) => {
  const { t, i18n } = useTranslation();
  const [retrying, setRetrying] = useState(false);
  const handleRetry = async () => {
    if (retrying) return;
    setRetrying(true);
    try {
      if (typeof navigator !== 'undefined' && navigator.onLine === false) {
        Toast.info(t('text163'));
        return;
      }
      if (onRetry) {
        await onRetry();
        return;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('user_lang', i18n.language);
      window.location.replace(url.toString());
    } finally {
      setRetrying(false);
    }
  };

  return (
    <div className='w-full min-h-screen bg-[#F7F7F7] flex flex-col items-center justify-center px-9 pb-20'>
      <img
        className='w-[8.75rem] h-[8.75rem]'
        src={require('@/assets/img/emptyState@3x.png')}
        alt=''
      />
      <p className='mt-5 mb-0 text-center text-15 leading-[1.125rem] text-black/60'>{t('text163')}</p>
      <button
        type='button'
        disabled={retrying}
        className='relative mt-6 w-auto min-w-[3.75rem] max-w-[10.75rem] min-h-[1.875rem] px-4 py-[0.4375rem] rounded-full bg-[#FF631B] text-white text-[0.875rem] leading-[1rem] flex items-center justify-center active:bg-[#FF7A3C] active:text-white/70'
        onClick={handleRetry}
      >
        <span className={`min-w-0 max-w-full text-center whitespace-normal break-words text-[0.875rem] leading-[1rem] ${retrying ? 'invisible' : ''}`}>{t('text196')}</span>
        {retrying && (
          <span className='absolute inset-0 flex items-center justify-center'>
            <Loading type='spinner' size='1rem' color='#fff' />
          </span>
        )}
      </button>
    </div>
  );
};

export default NetworkErrorPage;
